export const translateError = (error, t) => {
    const errorCode = error?.data?.code;
    if (errorCode && t(`errors.${errorCode}`, { defaultValue: '' })) {
      return t(`errors.${errorCode}`);
    }
    // Fallback: return message if available or a generic message
    return error?.data?.message || error?.message || t('errors.INTERNAL_SERVER_ERROR');
  };